import { DropdownAppearance as FluentDropdownAppearance, DropdownSize as FluentDropdownSize, DropdownType as FluentDropdownType } from "@fluentui/web-components";
/** Appearance values for {@link Dropdown}. */
export const DropdownAppearances = { ...FluentDropdownAppearance };
/** Size values for {@link Dropdown}. */
export const DropdownSizes = { ...FluentDropdownSize };
/** Dropdown type values for {@link Dropdown}. */
export const DropdownTypes = { ...FluentDropdownType };
//# sourceMappingURL=dropdown.options.js.map